import { useTranslate, IResourceComponentsProps } from '@pankod/refine-core'
import {
  Create,
  Form,
  Input,
  InputNumber,
  useForm
} from '@pankod/refine-antd'
import { definitions } from 'interfaces'

import 'react-mde/lib/styles/css/react-mde-all.css'

export const IgicTypeCreate: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm<definitions['igic_types']>()

  const t = useTranslate()

  return (
    <Create saveButtonProps={saveButtonProps} title={t('igic_types.titles.create')}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label={t('igic_types.fields.name')}
          name='name'
          rules={[
            {
              required: true
            }
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t('igic_types.fields.value')}
          name='value'
          rules={[
            {
              required: true
            }
          ]}
        >
          <InputNumber addonAfter={'%'} defaultValue={0} min={0} decimalSeparator=',' />
        </Form.Item>
      </Form>
    </Create>
  )
}
